export const chartTypes = {
  'counter:water:hot': {
    type: 'line',
    labels: [],
    datasets: [
      {
        label: 'Горячая, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgba(252, 165, 165, 0.2)',
        borderColor: 'rgba(239, 68, 68, 1)',
      },
    ],
  },

  'counter:water:cold': {
    type: 'line',
    labels: [],
    datasets: [
      {
        label: 'Холодная, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgba(147, 197, 253, 0.2)',
        borderColor: 'rgba(59, 130, 246, 1)',
      },
    ],
  },

  'counter:water': {
    type: 'line',
    labels: [],
    datasets: [
      {
        label: 'Вода, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgba(156, 163, 175, 0.2)',
        borderColor: 'rgb(156, 163, 175, 1)',
      },
    ],
  },

  'sensor:temperature': {
    type: 'line',
    labels: [],
    datasets: [
      {
        label: 'Температура, °C',
        data: [],
        fill: true,
        backgroundColor: 'rgb(196, 181, 253, 0.2)',
        borderColor: 'rgb(139, 92, 246, 1)',
      },
    ],
  },

  'sensor:water:leakage': {
    type: 'bar',
    labels: [],
    datasets: [
      {
        label: 'История срабатываний',
        data: [],
        fill: true,
        backgroundColor: 'rgba(239, 68, 68, 1)',
      },
    ],
  },

  'counter:water:hot:cons': {
    type: 'bar',
    labels: [],
    datasets: [
      {
        label: 'Расход горячей, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgba(239, 68, 68, 1)',
      },
    ],
  },

  'counter:water:cold:cons': {
    type: 'bar',
    labels: [],
    datasets: [
      {
        label: 'Расход холодной, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgba(59, 130, 246, 1)',
      },
    ],
  },

  'counter:water:cons': {
    type: 'bar',
    labels: [],
    datasets: [
      {
        label: 'Расход воды, m³',
        data: [],
        fill: true,
        backgroundColor: 'rgb(156, 163, 175, 1)',
      },
    ],
  },
};

export const chartOptions = {
  maintainAspectRatio: false,
  responsive: true,

  elements: {
    point: {
      radius: 2,
    },
    line: {
      borderWidth: 1.5,
    },
  },
  scales: {
    //'y-axis-0': {
    //  position: 'left',
    //},
    x: {
      //type: 'time',
      //time: {
      //  // unit: 'day',
      //  tooltipFormat: 'DD-MM-YYYY HH:mm:ss',
      //  displayFormats: {
      //    millisecond: 'HH:mm:ss.SSS',
      //    second: 'HH:mm:ss',
      //    minute: 'HH:mm',
      //    hour: 'HH',
      //    day: 'DD-MM-YY',
      //    week: 'DD-MM-YY',
      //    month: 'MM-YYYY',
      //    quarter: 'MM-YYYY',
      //    year: 'YYYY',
      //  },
      //},
      ticks: {
        source: 'data',
        display: true,
        maxTicksLimit: 8,
      },
      grid: {
        //color: 'rgba(0, 0, 0, 1)',
      },
    },
    y: {
      //min: 1,
      //max: 200,
      //type: 'logarithmic',
      ticks: {
        //color: 'rgba(0, 0, 0, 1)',
      },
      grid: {
        //color: 'rgba(0, 0, 0, 1)',
      },
    },
  },
  plugins: {
    title: { text: '' },
    legend: { display: true, position: 'bottom' },
    zoom: {
      zoom: {
        wheel: {
          enabled: true, // SET SCROOL ZOOM TO TRUE
          speed: 0.000001,
        },
        pinch: {
          enabled: true,
        },
        drag: {
          enabled: false,
        },
        mode: 'x',
        speed: 100,
      },
      pan: {
        enabled: true,
        mode: 'xy',
        speed: 100,
      },
    },
  },
};
